import React, { useState, useEffect } from 'react';
import {
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import SendIcon from '@mui/icons-material/Send';
import { fetchClaimChat, createClaimChat } from '../../action';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const ChatContainer = styled('div')({
  height: '300px',
  overflowY: 'auto',
  marginBottom: '1rem',
  border: '1px solid #ddd',
  borderRadius: '4px',
  padding: '1rem',
});

const MessageInput = styled(TextField)({
  width: '100%',
});

const ClaimChat = ({ claimUuid, disabled }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [message, setMessage] = useState('');
  const currentUser = useSelector(state => state.profileReducer.currentUserResponseData);
  const chatMessages = useSelector(state => state.fosaReducer.claimChatMessages);

  useEffect(() => {
    if (claimUuid) {
      dispatch(fetchClaimChat(claimUuid));
    }
  }, [claimUuid]);

  const handleSendMessage = () => {
    if (message.trim()) {
      console.log("=====> handle ==> ", message);
      dispatch(createClaimChat({
        claimUuid,
        message: message.trim()
      }, currentUser));

      setMessage('');

      const newMessage = {
        uuid: `temp-${Date.now()}`, // Temporary ID
        message: message.trim(),
        createdDate: new Date().toISOString(),
        sender: {
          id: currentUser.id,
          username: currentUser.username
        }
      };

      // Add message to UI immediately
      dispatch({
        type: 'ADD_CHAT_MESSAGE',
        payload: newMessage
      });
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  return (
    <StyledPaper>
      <Typography variant="h6" gutterBottom>
        {t("Chat")}
      </Typography>
      
      <ChatContainer>
        <List>
          {chatMessages?.map((chat, index) => (
            <React.Fragment key={chat.uuid}>
              <ListItem alignItems="flex-start">
                <ListItemText
                  primary={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Typography
                        component="span"
                        variant="body2"
                        color={chat.sender.id === currentUser.id ? "primary" : "textPrimary"}
                        >
                            <span style={{ fontWeight: 'bold' }}>{chat.sender.username}</span>
                        </Typography>

                        <Typography
                            component="span"
                            variant="caption"
                            color="textSecondary"
                        >
                            {formatDate(chat.createdDate)}
                        </Typography>
                    </div>
                  }
                  secondary={
                    <>
                      <Typography
                        component="span"
                        variant="body2"
                        color="textPrimary"
                      >
                        {chat.message}
                      </Typography>
                    </>
                  }
                />
              </ListItem>
              {index < chatMessages.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </ChatContainer>

      {!disabled && (
        <Grid container spacing={2}>
          <Grid item xs={10}>
            <MessageInput
              placeholder={t("Type a message")}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
            />
          </Grid>
          <Grid item xs={2}>
            <Button
              variant="contained"
              endIcon={<SendIcon />}
              onClick={handleSendMessage}
              disabled={!message.trim()}
              fullWidth
            >
              ENVOYER
            </Button>
          </Grid>
        </Grid>
      )}
    </StyledPaper>
  );
};

export default ClaimChat; 